import { createInertiaApp, router } from '@inertiajs/react'
import Layout from '@/components/Layout'
import { toast } from '@/lib/toast'

// Rails flash messages (notice/alert) arrive as one-off "flash" events, including on the first page load.
router.on('flash', (event) => {
  const { notice, alert } = event.detail.flash
  if (notice) toast(notice)
  if (alert) toast(alert, { tone: 'error' })
})

void createInertiaApp({
  pages: "../pages",

  strictMode: true,

  layout: () => Layout,

  title: (title, page) => (title ? `${title} · ${page.props.app_name}` : String(page.props.app_name)),

  progress: { color: '#3b82f6', delay: 250 },

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/service-worker.js'))
}
